import {getAxios, Pageable, PaginationSettings} from '@deviceinsight/ng-ui-api-client';
import {stringify} from 'qs';
import {Migration, MigrationToSave} from '../modules/assetManagement/types';
import {Device} from '../modules/ruleengine/types';

export const deleteMigration = (migrationId: string): Promise<Pageable<Migration>> =>
	getAxios()
		.delete(`/rafi/v1/migrations/${migrationId}`)
		.then((response) => response.data);

export const createMigration = (mig: MigrationToSave): Promise<Migration> =>
	getAxios()
		.post('/rafi/v1/migrations', mig)
		.then((response) => response.data);

export const listMigrations = (paginationSettings: PaginationSettings): Promise<Pageable<Migration>> => {
	let property = paginationSettings.sort.property;

	if (paginationSettings.sort.property === 'createdAt') {
		property = 'created_at';
	}
	if (paginationSettings.sort.property === 'completedAt') {
		property = 'completed_at';
	}
	const {
		page,
		size,
		sort: {direction}
	} = paginationSettings;
	const params = {
		page: page || 0,
		size,
		sort: `${property},${direction}`
	};
	return getAxios()
		.get(`/rafi/v1/migrations?${stringify(params)}`)
		.then((response) => response.data);
};

export const deleteDevice = (assetUrn: string): Promise<Pageable<Device>> =>
	getAxios()
		.delete(`/rafi/v1/devices/${assetUrn}`)
		.then((response) => response.data);
